<template>
	<div class="ai_container">
		<Header :title="'견적 내역'" :onPrev="handlePrev" :isShowHome="true" :returnName="'AiMain'"/>
		<div class="ai_wrapper_no_padding" v-if="items.length > 0">
			<ul >
				<EstimateItemCard  v-for="(item) in items" :key="item.estimateSeq" :item="item" />
			</ul>
		</div>
		<div v-else class="ai_wrapper_no_padding no_list">
			<div :class="'tac pt50'">견적 내역이 없어요.</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import Header from '../../components/ai/AiHeader.vue'
import EstimateItemCard from '../../components/ai/card/AiEstimateItemCard.vue'
import AppConfig from '@/config'

export default {
	name:'AiEstimateList',
	data() {
		return {
			items: [
			]
		}
	},
	components: {
		Header,
		EstimateItemCard,
		AppConfig
	},
	methods: {
		handlePrev() {
		},

		searchBtn() {
			const params = {
			}

			Vue.httpClient
			.post('/m/ai/dat/estimate/list', params)
			.then(response => {

				if(response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS){
					if (response.data.result) {
						this.items = response.data.result;
					} else {
						this.items = []
					}
				} else {
					throw new Error('response')
				}
			})
			.catch((e)=>{
				// console.log(e)
			})
			.finally(_ => {
				// console.log(this.items)

			});
		},

	},

	mounted(){
		this.searchBtn();
	}
}
</script>

<style scoped>
	.no_list {
		background-color: var(--gray-scale-10);
	}
</style>


// WEBPACK FOOTER //
// src/views/ai/AiEstimateList.vue